import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Select from 'mineral-ui/Select';
import themed from 'mineral-ui/themes/themed';
import {
  getCarrier,
} from '../../modules/selectors';
import api from '../../utils/services';
import { updateCarrier } from '../../modules/carrier';
import { updateFeatures } from '../../modules/features';
import { updateTheme, resetTheme } from '../../modules/theme';

const carrierSelectTheme = ({ theme }) => ({
  Select_backgroundColor: 'rgba(0, 0, 0, 0)',
  SelectIcon_color: theme.input_backgroundColor,
  Select_borderWidth: '1px',
  Select_borderColor: 'rgba(0, 0, 0, 0)',
  Select_fontSize_small: theme.h4_fontSize,
  Select_color: theme.input_backgroundColor,
  Select_borderColor_active: 'rgba(0, 0, 0, 0)',
  Select_color_placeholder: theme.input_backgroundColor,
  Select_borderColor_hover: theme.input_backgroundColor,
});


const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  addCarrier: PropTypes.func,
  currentCarrier: PropTypes.shape({
    carrierId: PropTypes.number,
    carrierName: PropTypes.string,
  }).isRequired,
  updateFeaturesOnCarrierChange: PropTypes.func,
  updateThemeOnCarrierChange: PropTypes.func,
  resetThemeIfColorFeatureDisabled: PropTypes.func,
};
const defaultProps = {
  addCarrier: null,
  updateFeaturesOnCarrierChange: null,
  updateThemeOnCarrierChange: null,
  resetThemeIfColorFeatureDisabled: null,
};

class CarrierSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carriers: null,
    };
  }

  componentDidMount() {
    api.getCarriers(100)
      .then((data) => {
        this.setState({ carriers: data });
      });
  }

  handleUpdateCarrier = (selectedCarrier) => {
    const {
      addCarrier,
      updateFeaturesOnCarrierChange,
      updateThemeOnCarrierChange,
      resetThemeIfColorFeatureDisabled,
      history,
    } = this.props;
    const { carriers } = this.state;
    const { id: selectedCarrierId } = selectedCarrier;
    // get the selected carrier from the list of carriers.
    const carrier = carriers.filter(c => c.id === selectedCarrierId)[0];
    // Add carrier to the store
    addCarrier(carrier);
    // Fetch the features that are enabled for the selected carriers.
    api.features(carrier.id)
      .then((data) => {
        const features = data.reduce((acc, f) => {
          acc[f.type] = f.enabled;
          return acc;
        }, {});
        // After the successful request, add the features to the redux store.
        updateFeaturesOnCarrierChange(features);
        api.theme(carrier.id)
          .then((themeResponse) => {
            // If theme is not found in the database then default the theme to the Global theme.
            if (themeResponse.length > 0) {
              const { value } = themeResponse[0];
              updateThemeOnCarrierChange(JSON.parse(value));
            } else {
              resetThemeIfColorFeatureDisabled();
            }
          });
      });
    history.push(`/carriers/${selectedCarrier.id}`);
  }

  render() {
    const { carriers } = this.state;
    const { currentCarrier } = this.props;

    const selectData = (carriers || []).map(carrier => ({
      text: carrier.name,
      id: carrier.id,
      value: carrier.name,
    }));
    const selectProps = {
      data: selectData,
      selectedItem: {
        id: currentCarrier.carrierId,
        text: currentCarrier.carrierName,
        value: currentCarrier.carrierName,
      },
      size: 'small',
      placeholder: 'Default',
      onChange: this.handleUpdateCarrier,
    };
    return (
      <Select {...selectProps} />
    );
  }
}
CarrierSelect.propTypes = propTypes;
CarrierSelect.defaultProps = defaultProps;
function mapStateToProps(state) {
  return {
    currentCarrier: getCarrier(state),
  };
}

const mapDispatchToProps = dispatch => ({
  addCarrier: carrierId => dispatch(updateCarrier(carrierId)),
  updateFeaturesOnCarrierChange: features => dispatch(updateFeatures(features)),
  updateThemeOnCarrierChange: theme => dispatch(updateTheme(theme)),
  resetThemeIfColorFeatureDisabled: () => dispatch(resetTheme()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(themed(CarrierSelect)(carrierSelectTheme)),
);
